<registration-settings-panel />
